export default "__VITE_ASSET__D6QZhsxe__"